import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-qr-code-modal',
    templateUrl: './qr-code-modal.component.html',
    styleUrls: ['./qr-code-modal.component.css'],
    standalone: false
})
export class QrCodeModalComponent  {
 @Input() qrCodeData: string = '';
  @Input() partnerName: string = '';
  @Input() description: string = 'Use this QR code to view partner details';
  @Input() showPartnerName: boolean = true;

  constructor(public activeModal: NgbActiveModal) {}

  getQrCodeUrl(size: number = 400): string {
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(this.qrCodeData)}`;
  }

  downloadQrCode(): void {
    const qrCodeUrl = this.getQrCodeUrl(1000);

    fetch(qrCodeUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${this.partnerName.replace(/\s+/g, '_')}_QR_Code.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading QR code:', error);
      });
  }

}
